import type { Database } from "./database.types";

export type ProfileRow = Database["public"]["Tables"]["profiles"]["Row"];
export type WorkspaceRow = Database["public"]["Tables"]["workspaces"]["Row"];
export type WorkspaceMemberRow = Database["public"]["Tables"]["workspace_members"]["Row"];
export type WorkspacePreferencesRow = Database["public"]["Tables"]["workspace_preferences"]["Row"];

export interface AppIdentity {
  userId: string;
  email: string | null;
  displayName: string;
  workspaceId: string;
  workspaceName: string;
  role: WorkspaceMemberRow["role"];
  timezone: string;
}

export function adaptIdentity(input: {
  userId: string;
  email: string | null;
  profile: Pick<ProfileRow, "display_name"> | null;
  membership: Pick<WorkspaceMemberRow, "workspace_id" | "role">;
  workspace: Pick<WorkspaceRow, "name"> | null;
  preferences: Pick<WorkspacePreferencesRow, "timezone"> | null;
}): AppIdentity {
  const displayName =
    input.profile?.display_name?.trim() ||
    (input.email ? input.email.split("@")[0] : undefined) ||
    "Usuário";

  return {
    userId: input.userId,
    email: input.email,
    displayName,
    workspaceId: input.membership.workspace_id,
    workspaceName: input.workspace?.name ?? "Espaço pessoal",
    role: input.membership.role,
    timezone: input.preferences?.timezone ?? "America/Sao_Paulo",
  };
}
